// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2a53691d","455":"30e411b7","977":"03b54764"}[chunkId] + ".chunk.js";
};